import { render, staticRenderFns } from "./Fifth.vue?vue&type=template&id=a0e8cdac&scoped=true"
import script from "./Fifth.vue?vue&type=script&lang=js"
export * from "./Fifth.vue?vue&type=script&lang=js"
import style0 from "./Fifth.vue?vue&type=style&index=0&id=a0e8cdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8cdac",
  null
  
)

export default component.exports